import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState({
    storage: window.sessionStorage,
})],
  state: {    
    storeName: '',
    managerNames: [],
    selectedManagers: [],
    assignedManagers: {},
    province: '',
    userData: {},
    pin: null,
    code: null,
    pointRate: 0,
    currency: "CA",
    domain: null
  },
  getters: {
    userName: state => `${state.userData.employeeFirstName} ${state.userData.employeeLastName}`,
    pointRate: state => state.pointRate,
    currency: state => state.currency,
    domain: state => state.domain
  },
  mutations: {
    changeStoreName(state, name){
      state.storeName=name
    },
    updateManagersNames(state, managerNames){
      state.managerNames=managerNames
    },
    updateSelectedManagers(state, selectedManagers){
      state.selectedManagers=selectedManagers
    },
    updateAssingedManagers(state,assignedManagers){
      state.assignedManagers=assignedManagers
    },
    updateProvinceName (state, data) {
      state.province = data
    },
    updateUserData (state, data) {
      state.userData = data
    },
    updatePin (state, data) {
      state.pin = data
    },
    updateCode (state, data) {
      state.code = data
    },
    updateUserName (state, data) {
      state.userName = data
    },
    updatePointRate (state, data) {
      state.pointRate = data
    },
    updateCurrenct (state, data) {
      state.currency = data
    },
    setDomain (state, data) {
      state.domain = data
    }
  },
  actions: {},
  modules: {
  }
});
